import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import "./tabs.scss";
import { cleanString } from "oj-utils";
import { animateClassNames, animateCreate, animateRemove } from "oj-mithriljs-utils";
import { pause } from "oj-promise-utils";
import { Frag } from "../frag/frag";
class Content extends MithrilTsxComponent {
    static prevIdx = -1;
    static direction = 1;
    dom;
    oninit(v) {
        if (v.attrs.idx >= Content.prevIdx)
            Content.direction = 1;
        else if (v.attrs.idx < Content.prevIdx)
            Content.direction = -1;
        Content.prevIdx = v.attrs.idx ?? -1;
    }
    view(v) {
        return m("div", { className: cleanString("Content", Content.direction === 1 ? "right" : "left", animateClassNames(v)) }, v.children);
    }
    async oncreate(v) {
        this.dom = v.dom;
        animateCreate(v);
        let h;
        let attempts = 0;
        const maxAttempts = 1000;
        while (attempts < maxAttempts) {
            const _h = v.dom.scrollHeight;
            if (_h && h === _h)
                break;
            h = _h;
            attempts++;
            await pause(50).promise;
        }
        v.attrs.onheightchange?.(v.dom.scrollHeight);
    }
    async onbeforeremove(v) {
        const dom = v.dom;
        await pause(0).promise;
        dom.classList.remove("right", "left");
        dom.classList.add(Content.direction === 1 ? "right" : "left");
        return animateRemove(v);
    }
}
export class Tabs extends MithrilTsxComponent {
    contentEl;
    view(v) {
        const index = v.attrs.tabs.findIndex(tab => tab.key === v.attrs.tab);
        const content = v.attrs.tabs[index]?.content;
        return m("div", { className: "Tabs" },
            m("div", { className: "tab-headers" }, v.attrs.tabs.map(tab => m("div", { className: `tab-header ${v.attrs.tab === tab.key ? "active" : ""}`, onclick: () => v.attrs.onchange(tab.key) }, tab.label))),
            m("div", { className: "tab-content", oncreate: ({ dom }) => this.contentEl = dom },
                m(Content, { key: v.attrs.tab, idx: index, onheightchange: (height) => {
                        this.contentEl.style.height = `${height}px`;
                    } }, content?.()),
                m(Frag, { key: "children" }, v.children)));
    }
}
